import { CompSearch } from '../types.ts';

const FILTER_FIELD_LABELS: Partial<Record<keyof CompSearch['filters'], string>> = {
  propertySubType: 'Property Type',
  saleDate: 'Sale Date',
  salePrice: 'Sale Price',
  gla: 'GLA',
  lotSize: 'Site Size',
  yearBuilt: 'Year Built',
  bedrooms: 'Bedrooms',
  fullBaths: 'Full Baths',
  halfBaths: 'Half Baths',
  stories: 'Stories',
  garageSpaces: 'Garage Spaces',
  quality: 'Quality',
  condition: 'Condition',
  hasBasement: 'Basement',
  hasPool: 'Pool',
  keywords: 'Keyword search',
};

const CLIENT_ONLY_FILTER_KEYS = [
  'quality',
  'condition',
] as const satisfies readonly (keyof CompSearch['filters'])[];

const CLIENT_ONLY_MATCH_CRITERIA_KEYS = [
  'quality',
  'condition',
] as const satisfies readonly (keyof CompSearch['matchCriteria'])[];

const omitClientOnlyFilters = (search: CompSearch) => {
  const filters = { ...search.filters };
  const matchCriteria = { ...search.matchCriteria };
  CLIENT_ONLY_FILTER_KEYS.forEach((key) => {
    delete filters[key];
  });
  CLIENT_ONLY_MATCH_CRITERIA_KEYS.forEach((key) => {
    delete matchCriteria[key];
  });
  return { filters, geoSearch: search.geoSearch, matchCriteria };
};

export const didServerCompSearchChange = (original: CompSearch, applied: CompSearch): boolean =>
  JSON.stringify(omitClientOnlyFilters(original)) !== JSON.stringify(omitClientOnlyFilters(applied));

export const getChangedSearchFilterLabels = (
  original: CompSearch,
  applied: CompSearch,
): string[] => {
  const changedFilterLabels = Object.entries(FILTER_FIELD_LABELS)
    .filter(([field]) => {
      const key = field as keyof CompSearch['filters'];
      return JSON.stringify(original.filters[key]) !== JSON.stringify(applied.filters[key]);
    })
    .map(([, label]) => label as string);

  const geoSearchChanged = JSON.stringify(original.geoSearch) !== JSON.stringify(applied.geoSearch);

  return geoSearchChanged ? [...changedFilterLabels, 'Search Area'] : changedFilterLabels;
};
